import type { TransportRouteDetailDto } from '../../dto/transport';
import { parseDate } from '../../utils/dateUtils';
import { getTransportLabel } from '../../utils/transportLabel';

// The one rule for which trucks of a ZK are shown and in what order — used by
// „Dostawy w trasie” (OrderTransportStatusStrip) and „Sposób realizacji”
// (OrderPlanAside).

/** Planned delivery shown on the row: the actual date for delivered trucks, otherwise the planned one. */
export const getRowDeliveryDate = (transport: TransportRouteDetailDto): string => {
  const isDelivered = transport.status === 'DELIVERED';
  return isDelivered
    ? transport.actualDelivery || transport.estimatedDelivery || transport.estimatedArrival
    : transport.estimatedDelivery || transport.estimatedArrival;
};

const getSortTime = (transport: TransportRouteDetailDto): number | null => {
  const time = parseDate(getRowDeliveryDate(transport))?.valueOf();
  return time !== undefined && Number.isFinite(time) ? time : null;
};

/** Hidden cancelled trucks removed; rows ordered by the date they show, undated rows last, same date by truck number. */
export const getVisibleOrderTransports = (
  transports: TransportRouteDetailDto[],
): TransportRouteDetailDto[] => transports
  .filter((transport) => transport.status !== 'CANCELLED')
  .map((transport) => ({ transport, time: getSortTime(transport) }))
  .sort((a, b) => {
    if (a.time === b.time) {
      const left = getTransportLabel(a.transport);
      const right = getTransportLabel(b.transport);
      if (!left || !right) return left ? -1 : right ? 1 : 0;
      return left.localeCompare(right, 'pl', { numeric: true });
    }
    if (a.time === null) return 1;
    if (b.time === null) return -1;
    return a.time - b.time;
  })
  .map(({ transport }) => transport);
